'use strict';

var Backbone = require('backbone'),

  LinkProjectModel = Backbone.Model.extend({

    defaults: {
      state: '' // 'add' / 'delete'
    }

  }, {
    STATE: {
      add: 'add',
      delete: 'delete'
    }
  });

module.exports = LinkProjectModel;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/LinkProjectModel.js